import {
  ScreenSharingInfo,
  ScreenSharingInfoAndChat,
  ScreenSharingStatus,
} from '@agent/agent-interface/contact-view/chat/model/screen-sharing-info';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenSharingStatusService {
  private readonly _screenSharingInfo$ = new BehaviorSubject<ScreenSharingInfoAndChat | null>(null);
  readonly screenSharingInfo$ = this._screenSharingInfo$.asObservable();

  updateScreenSharingStatus(data: ScreenSharingInfoAndChat): void {
    if (!data) {
      throw new Error('data must be provided');
    }
    if (!data.chat) {
      throw new Error('data.chat must be provided');
    }
    if (!data.info) {
      data.info = new ScreenSharingInfo(ScreenSharingStatus.NOT_STARTED);
    }
    this._screenSharingInfo$.next(data);
  }
}
